export default __webpack_public_path__ + "static/media/11.99247bc0.png";